export const SET_PAGE_DATA = "SET_PAGE_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_SOCIAL_DATA = "SET_SOCIAL_DATA";
export const SET_LANG = "SET_LANG";
